import { User } from 'src/app/services/user/model/user';
export class UserTransaction {
  currentDate?: Date;
  description?: string;
  id?: number;
  onHold?: boolean;
  originalValue?: number;
  transactionType?: string;
  type?: string;
  user?: User;
  userFrom?: User;
  userFromId?: number;
  userId?: number;
  value?: number;
  txuuid?: string;
}
